module.exports = __webpack_public_path__ + "assets/expand-big-04fcb024c9267e36cda89b4362746ce6.svg";